<script lang="ts">
  import { parseAmount, formatNumber } from '../format';
  import { prefs } from '../prefs.svelte';
  import Input from './Input.svelte';

  interface Props {
    value?: number | null;
    placeholder?: string;
    disabled?: boolean;
    id?: string;
    suffix?: string;
    onchange?: (value: number | null) => void;
  }
  let { value = $bindable(null), placeholder = '0,00', disabled = false, id, suffix, onchange }: Props = $props();
  const symbol = $derived({ EUR: '€', USD: '$', GBP: '£', CHF: 'CHF' }[prefs.value.currency]);
  let text = $state('');
  let focused = $state(false);
  $effect(() => {
    if (!focused) text = value === null || value === undefined ? '' : formatNumber(value, 2);
  });
  function commit() {
    focused = false;
    const parsed = parseAmount(text);
    value = parsed;
    text = parsed === null ? '' : formatNumber(parsed, 2);
    onchange?.(parsed);
  }
</script>

<Input
  {id}
  bind:value={text}
  prefix={symbol}
  {suffix}
  inputmode="decimal"
  autocomplete="off"
  {placeholder}
  {disabled}
  onfocus={() => (focused = true)}
  onblur={commit}
/>
